// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CustomerOrderItemModel from '../../model/customer-order-item-model';
import CustomerOrderItemDTO from '../dto/customer-order-item-dto';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class CustomerOrderItemModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CustomerOrderItemDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.customerOrderId = data.customerOrderId;
      this.productId = data.productId;
      this.quantity = data.quantity;
      this.selectedTitles = data.selectedTitles ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;
  /**
  */
  'links'?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  'creatorId'?: number;
  /**
  */
  'creatorName'?: string;
  /**
  * @type {date-time}
  */
  'created'?: string;
  /**
  * @type {int64}
  */
  'modifierId'?: number;
  /**
  */
  'modifierName'?: string;
  /**
  * @type {date-time}
  */
  'modified'?: string;
  /**
  * @type {int64}
  */
  'customerOrderId'?: number;
  /**
  * @type {int64}
  */
  'productId'?: number;
  /**
  * @type {double}
  */
  'quantity'?: number;
  /**
  */
  'selectedTitles'?: string[];

  static toModel(dto: DeepPartial<CustomerOrderItemDTO>): CustomerOrderItemModel;
  static toModel(dto: DeepPartial<CustomerOrderItemDTO> | undefined | null): CustomerOrderItemModel | undefined;
  static toModel(dto: DeepPartial<CustomerOrderItemDTO> | undefined | null): CustomerOrderItemModel | undefined {
    return dto ? new CustomerOrderItemModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CustomerOrderItemModel> | CustomerOrderItemModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
      'links': unwrapped.links,
      'creatorId': unwrapped.creatorId,
      'creatorName': unwrapped.creatorName,
      'created': unwrapped.created,
      'modifierId': unwrapped.modifierId,
      'modifierName': unwrapped.modifierName,
      'modified': unwrapped.modified,
      'customerOrderId': unwrapped.customerOrderId,
      'productId': unwrapped.productId,
      'quantity': unwrapped.quantity,
      'selectedTitles': unwrapped.selectedTitles,
    } as CustomerOrderItemDTO;
  }
}
